import { render, staticRenderFns } from "./PasswordSet.vue?vue&type=template&id=63083dee"
import script from "./PasswordSet.vue?vue&type=script&lang=ts"
export * from "./PasswordSet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports